import { useQuery } from "@tanstack/react-query";
import { CampaignsService } from "@/services/campaigns.service";
import { adsHttpClient } from "@/utils/ads.http";

const campaignsService = new CampaignsService(adsHttpClient);

export function useCampaign(campaignId: string | undefined) {
  return useQuery({
    queryKey: ["campaigns", campaignId],
    queryFn: () => campaignsService.getById(campaignId ?? ""),
    enabled: Boolean(campaignId),
  });
}
